import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="pt-16 md:pt-20 px-4 md:px-8 flex flex-col items-center justify-center min-h-[70vh] text-center">
      <p className="font-heading font-black text-7xl md:text-9xl text-primary-500/40 select-none">404</p>
      <h1 className="mt-4 font-heading font-bold text-xl md:text-2xl text-foreground-950">
        抱歉，这个页面走丢了
      </h1>
      <p className="mt-2 text-sm text-foreground-500 font-mono break-all">{location.pathname}</p>
      <p className="mt-3 text-sm text-foreground-600">你访问的页面不存在，去看看别的内容吧。</p>
      <div className="flex flex-wrap justify-center gap-3 mt-7">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-md font-medium whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
        >
          <i className="ri-home-4-line" /> 返回首页
        </Link>
        <Link
          to="/category/movie"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-md font-medium whitespace-nowrap bg-background-200/80 text-foreground-950 hover:bg-background-200 transition-colors cursor-pointer"
        >
          <i className="ri-grid-line" /> 浏览分类
        </Link>
      </div>
    </div>
  );
}